module.exports = __webpack_public_path__ + "site/img/26.cce86a04.jpg";